(() => {
  if (window.GMLStory) { window.GMLStory.init(); return; }
  const controllers = new WeakMap();
  const clamp = (value) => Math.max(0, Math.min(1, value));
  const initRoot = (root) => {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    const { signal } = controller;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scene = root.querySelector('[data-story-scene]');
    const intro = root.querySelector('[data-story-introduction]');
    const values = root.querySelector('[data-story-values]');
    const editor = Boolean(window.Shopify?.designMode);
    let frame = 0;
    let observer;
    const update = () => {
      frame = 0;
      if (reduced.matches || editor || !scene || !intro || !values) return;
      const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--gml-header-height')) || 80;
      const height = Math.max(480, window.innerHeight - header);
      const introTop = intro.getBoundingClientRect().top - header;
      const valuesTop = values.getBoundingClientRect().top - header;
      const darkness = clamp((height * .9 - introTop) / (height * .9));
      const crossfade = clamp((height * .95 - valuesTop) / (height * .85));
      const base = parseFloat(getComputedStyle(root).getPropertyValue('--gml-story-base-shade')) || .3;
      root.style.setProperty('--story-shade', String(base + darkness * (.78 - base)));
      root.style.setProperty('--story-second', String(crossfade));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const configure = () => {
      observer?.disconnect();
      root.classList.toggle('gml-story--motion', !reduced.matches && !editor);
      if (reduced.matches || editor) {
        root.querySelectorAll('[data-story-reveal]').forEach((element) => element.classList.add('is-visible'));
        root.style.removeProperty('--story-second');
        root.style.removeProperty('--story-shade');
        return;
      }
      observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });
      root.querySelectorAll('[data-story-reveal]').forEach((element) => observer.observe(element));
      schedule();
    };
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    window.addEventListener('pageshow', schedule, { signal });
    reduced.addEventListener('change', configure, { signal });
    document.addEventListener('shopify:block:select', (event) => {
      if (!root.contains(event.target)) return;
      event.target.classList.add('is-visible');
    }, { signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      controller.abort();
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      controllers.delete(root);
    }, { signal });
    configure();
  };
  const init = () => document.querySelectorAll('[data-gml-story]').forEach(initRoot);
  window.GMLStory = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
